import { Helmet } from "react-helmet";
import React from "react";
import styled from "styled-components";
import { Box, Grid, Paper, Stack } from "@mui/material";
import CustomTooltip from "src/components/custom-tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import request from "src/utils/request";
import { Skeleton } from "@mui/lab";
import BadgeAchieventProfile from "src/components/badge-achievent-profile";
import inIframe from "src/components/in-iframe";
import PublicProfilePriveted from "src/scenes/personal-profile-public/public-profile-priveted";

const CardContainer = styled(Paper)`
    border-radius: 14px;
    border: 2px solid transparent;
`;

const MainText = styled.p`
    font-size: 13px;
    padding: 12px;
    margin: 0;
`;

const SecondaryText = styled.p`
    font-size: 11px;
    margin: 0;
`;

const ValueText = styled.p`
    font-size: 11px;
    border-radius: 30px;
    background-color: #333333;
    height: 24px;
    width: 44px;
    margin: 0 0 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
`;

const AchievementsStack = styled(Stack)`
    background-color: #333333;
    border-radius: 14px;
    margin-top: 8px;
    // padding-top: 5px;
    padding-left: 5px;
    min-height: 74px;
`;

const UserImage = styled.img`
    border-radius: 70px;
    border: 3px solid #f9cd45;
    min-height: 80px;
    min-width: 80px;
`;

const RankingBox = styled(Box)`
    width: 49px;
    height: 21px;
    background-color: #f9cd45;
    color: #333333;
    border-radius: 4px;
`;

const RankNumber = styled.p`
    margin: 0;
    font-weight: 800;
    padding-left: 4px;
`;

const PublicPersonalProfile = () => {
    const [profileData, setProfileData] = React.useState([]);
    const [userData, setUserData] = React.useState();
    const [isPrivate, setIsPrivate] = React.useState(false);

    const getPersonalProfile = async () => {
        try {
            const path = window.location.pathname;
            const hasHandle = path.match(/\/personal-profile\/(.+)/);
            const handle = hasHandle ? hasHandle[1] : null;
            const response = await request(`/api/users/${handle}/stats`, { method: "GET" });
            setProfileData(response);
        } catch (error) {
            console.log("This profile is private");
            setIsPrivate(true);
        }
    };

    const getUser = async () => {
        const path = window.location.pathname;
        const hasHandle = path.match(/\/personal-profile\/(.+)/);
        const handle = hasHandle ? hasHandle[1] : null;
        const response = await request(`/api/users/public/${handle}`, { method: "GET" });
        setUserData(response);
    };

    React.useEffect(() => {
        getPersonalProfile();
        getUser();
    }, []);

    const filterObjectValue = (stats) => {
        if (!Array.isArray(stats)) {
            return stats;
        }

        const filteredStats = stats.filter((stat) => {
            return typeof stat.value !== "object";
        });

        return filteredStats;
    };
    const keepOnlyObjects = (stats) => {
        if (!Array.isArray(stats)) {
            return stats;
        }

        const filteredStats = stats.filter((item) => typeof item.value === "object");
        return filteredStats;
    };
    const toSort = profileData.stats;
    const sortedProfileData = filterObjectValue(toSort);
    const sortedProfileObjects = keepOnlyObjects(profileData.stats);
    if (isPrivate === true) return <PublicProfilePriveted />;
    return (
        <>
            <Helmet>
                <title>Adadot - Personal Profile</title>
            </Helmet>
            {profileData && profileData.length !== 0 ? (
                <Stack direction="column" alignItems="flex-end">
                    <CardContainer>
                        <Grid container justifyContent="center">
                            <Grid item id="user" md={2}>
                                <Stack
                                    direction="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    style={{ height: "338px" }}
                                >
                                    <div
                                        direction="column"
                                        alignItems="center"
                                        style={{ height: "95px" }}
                                    >
                                        <UserImage
                                            src={userData && userData.picture}
                                            alt="Profile"
                                            style={{
                                                borderRadius: "70px",
                                                maxWidth: "80px",
                                                maxHeight: "80px",
                                                position: "relative",
                                                top: 0,
                                                left: 0,
                                            }}
                                        />
                                        {userData &&
                                            userData.rank &&
                                            userData.rankVisibility === "public" && (
                                                <CustomTooltip title="Adadot Ranking">
                                                    <RankingBox
                                                        style={{
                                                            position: "relative",
                                                            top: "-21px",
                                                            left: "17px",
                                                        }}
                                                    >
                                                        <RankNumber># {userData.rank}</RankNumber>
                                                    </RankingBox>
                                                </CustomTooltip>
                                            )}
                                    </div>
                                    <MainText>{userData && userData.displayName}</MainText>
                                    <SecondaryText>{userData && userData.jobTitle}</SecondaryText>
                                    <SecondaryText>{userData && userData.website}</SecondaryText>
                                </Stack>
                            </Grid>
                            <Grid item id="data" md={10} p={4}>
                                <Stack direction="row">
                                    <Grid container spacing={2} md={12} justifyContent="flex-start">
                                        {sortedProfileData.map((item) => {
                                            return (
                                                <Grid item key={item.title} md={6} xs={12}>
                                                    <Stack
                                                        direction="row"
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                    >
                                                        <SecondaryText>{item.title}</SecondaryText>
                                                        <ValueText>{item.value}</ValueText>
                                                    </Stack>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                    <Grid item key={sortedProfileObjects[0].title} md={4} xs={12}>
                                        <Grid
                                            direction="column"
                                            alignItems="flex-start"
                                            justifyContent="space-between"
                                            style={{
                                                width: "100%",
                                                marginLeft: "16px",
                                            }}
                                        >
                                            <SecondaryText
                                                style={{
                                                    opacity: "0.5",
                                                    paddingTop: "2px",
                                                    paddingBottom: "2px",
                                                }}
                                            >
                                                {sortedProfileObjects[0].title}
                                            </SecondaryText>
                                            <Grid direction="column" justifyContent="space-between">
                                                {Object.entries(sortedProfileObjects[0].value).map(
                                                    ([title, value]) => (
                                                        <Stack
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="space-between"
                                                            mt={2}
                                                        >
                                                            <SecondaryText>{title}</SecondaryText>
                                                            <ValueText
                                                                style={{
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                {value}
                                                            </ValueText>
                                                        </Stack>
                                                    )
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Stack>

                                <SecondaryText style={{ paddingTop: "26px", opacity: "0.4" }}>
                                    Latest Achievements
                                </SecondaryText>
                                <AchievementsStack direction="row" spacing={2}>
                                    <Grid container direction="row">
                                        {profileData &&
                                            profileData.achievements &&
                                            profileData.achievements.latest.map((achievement) =>
                                                BadgeAchieventProfile({ achievement })
                                            )}
                                    </Grid>
                                </AchievementsStack>
                            </Grid>
                        </Grid>
                    </CardContainer>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item>
                            {inIframe() && (
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <SecondaryText>Powered by</SecondaryText>
                                    <a href="https://me.adadot.com">
                                        <Box
                                            component="img"
                                            sx={{
                                                height: "48px",
                                                width: "106px",
                                            }}
                                            alt="Adadot logo"
                                            src="https://assets.adadot.com/logos/logo-dark-nobg.svg"
                                        />
                                    </a>
                                </Stack>
                            )}
                        </Grid>
                        <Grid item>
                            <CustomTooltip title="Your profile views">
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    p={1}
                                    style={{ opacity: "0.5" }}
                                >
                                    <VisibilityIcon fontSize="small" />
                                    <p>{profileData.views}</p>
                                </Stack>
                            </CustomTooltip>
                        </Grid>
                    </Grid>
                </Stack>
            ) : (
                <Skeleton
                    variant="rounded"
                    animation="wave"
                    width="60vw"
                    height="30vh"
                    sx={{ borderRadius: "14px" }}
                />
            )}
        </>
    );
};

export default PublicPersonalProfile;
